module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lipBalm_e95752.png";